import { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGPolygonElement>, 'points'> & {
  size: number;
};

const Triangle = ({ fill = 'none', size, ...polygonProps }: Props) => {
  const points = [
    [size, size],
    [size / 2, size / 2],
    [0, size],
  ]
    .map((item) => item.join(','))
    .join(' ');

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points={points} strokeWidth={3} fill={fill} {...polygonProps} />
    </svg>
  );
};

export default Triangle;
